import { render, staticRenderFns } from "./NewFormationPopup.vue?vue&type=template&id=16bec8a5&"
import script from "./NewFormationPopup.vue?vue&type=script&lang=js&"
export * from "./NewFormationPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports